module.exports = __webpack_public_path__ + "img/shanghaidianqi.2a9c0f31.png";